import { useEffect, useState } from "react";
import { Phone, CalendarClock } from "lucide-react";
import { api } from "../lib/api";
import { PageHeader, Card } from "../components/PageHeader";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { StageBadge } from "../components/Badges";
import { LeadDrawer } from "../components/LeadDrawer";

const STATE_CLS = { overdue: "bg-rose-50 text-rose-700 border-rose-200", today: "bg-amber-50 text-amber-700 border-amber-200", upcoming: "bg-blue-50 text-blue-700 border-blue-200" };

export default function FollowUps() {
  const [scope, setScope] = useState("all");
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);
  const load = () => api.get("/followups", { params: { scope } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [scope]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="followups-page">
      <PageHeader title="Follow-ups" subtitle="All pending follow-ups across your active leads." />
      <Tabs value={scope} onValueChange={setScope} className="mb-4">
        <TabsList>
          {["all", "overdue", "today", "upcoming"].map((s) => <TabsTrigger key={s} value={s} className="capitalize" data-testid={`followups-tab-${s}`}>{s}</TabsTrigger>)}
        </TabsList>
      </Tabs>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map((f) => (
          <Card key={`${f.lead_id}-${f.no}`} className="p-4 cursor-pointer hover:border-emerald-300 transition-colors" onClick={() => setSel(f.lead_id)} data-testid={`followup-card-${f.lead_id}-${f.no}`}>
            <div className="flex items-center justify-between">
              <span className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize ${STATE_CLS[f.state]}`}>{f.state}</span>
              <span className="text-xs font-semibold text-slate-500">Follow-up #{f.no}</span>
            </div>
            <div className="mt-3 font-semibold">{f.lead_name}</div>
            <div className="text-xs text-slate-500">{f.company}</div>
            <div className="mt-3 flex items-center gap-2 text-sm text-slate-600"><CalendarClock className="h-4 w-4 text-slate-400" />{new Date(f.date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</div>
            {f.phone && <div className="mt-1 flex items-center gap-2 text-sm text-slate-600"><Phone className="h-4 w-4 text-slate-400" />{f.phone}</div>}
            {f.remarks && <div className="mt-2 text-sm text-slate-500 line-clamp-2">{f.remarks}</div>}
            <div className="mt-3 flex items-center justify-between"><StageBadge status={f.lead_status} /><span className="text-xs text-slate-500">{f.assigned_name}</span></div>
          </Card>
        ))}
        {!items.length && <div className="text-slate-500 py-10" data-testid="followups-empty">No follow-ups in this view. Great job!</div>}
      </div>
      <LeadDrawer leadId={sel} onClose={() => setSel(null)} onChanged={load} />
    </div>
  );
}
